import { useGetApiV1RbacActorsByActorIdPermissionsQuery } from '../../authApi'
import { userSlice } from '@wellesley/user/slices/userSlice'
import { useSelector } from 'react-redux'
import { UserPermissions } from '../../types/access'

export const useUserPermissions = (scope?: string) => {
  const user = useSelector(userSlice.selectors.selectCurrentUser)
  const {
    data: userPermissions,
    isLoading,
    isError,
    error,
  } = useGetApiV1RbacActorsByActorIdPermissionsQuery(
    {
      actorId: user?.id || '',
      ...(scope && { scope }),
    },
    { skip: !user },
  )

  return {
    userPermissions: userPermissions as unknown as UserPermissions,
    isLoading,
    isError,
    error,
  }
}
